import React from 'react'

const ArrowRightSm = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.48731 2.97574C4.29086 2.81872 4 2.95859 4 3.21008V8.78995C4 9.04144 4.29086 9.18131 4.48731 9.02429L7.97782 6.23436C8.12807 6.11426 8.12807 5.88577 7.97782 5.76567L4.48731 2.97574Z" fill="currentColor"/>
  </svg>
)
export default ArrowRightSm;
